import { registerSW } from "virtual:pwa-register";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AdminApp from "./admin/AdminApp";
import "@mantine/notifications/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/tiptap/styles.css";
import type { AuthConfig } from "@aws-amplify/core";
import * as Sentry from "@sentry/react";
import { Amplify } from "aws-amplify";
import { config } from "./config";

if (config.environment !== "localhost") {
  Sentry.init({
    dsn: config.sentryDsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: config.environment,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}

registerSW({
  onNeedRefresh() {
    // You can show a prompt to user here to refresh the page
    console.log("New content available, please refresh the page.");
  },
  onOfflineReady() {
    console.log("App ready to work offline");
  },
});

const rootElement = document.getElementById("root");
if (rootElement) {
  // Check if the current URL starts with /admin
  const isAdminPath = window.location.pathname.startsWith("/admin");
  let authConfig: AuthConfig["Cognito"];

  if (isAdminPath) {
    authConfig = {
      ...config.adminCognitoConfig,
      loginWith: {
        oauth: {
          domain: config.adminCognitoConfig.oauthDomain,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [`${window.location.origin}/admin`],
          redirectSignOut: [`${window.location.origin}/admin`],
          responseType: "code",
        },
      },
    };
  } else {
    authConfig = config.amplifyCognitoConfig;
  }

  Amplify.configure({
    Auth: {
      Cognito: authConfig,
    },
  });

  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <PostHogProvider
        apiKey={config.posthog.publicKey}
        options={{
          api_host: config.posthog.publicHost,
          defaults: "2025-05-24",
          capture_exceptions: true,
        }}
      >
        {isAdminPath ? <AdminApp /> : <App />}
      </PostHogProvider>
    </StrictMode>,
  );
}
